import React from 'react';
import { path, prop } from 'ramda';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { useAppSelector } from 'js/store/hooks';
import { truncateExtraDecimals } from 'js/utils/math.util';
import style from './index.scss';

export const rankStyles = {
    1: style.gold,
    2: style.silver,
    3: style.bronze
};

export const rankFonts = {
    2: style.twoDigits,
    3: style.threeDigits,
    4: style.fourDigits,
    5: style.fiveDigits
};

export const Row = ({
    rank,
    name,
    score,
    isMarkRank,
    isMe,
    isNoPrize,
    addDivider,
    prizeDescription,
    isPrizesAvailable
}) => {
    const scorePlaces = useAppSelector(path(['leaderboard', 'scorePlaces']));

    return (
        <>
            {addDivider && <div className={style.divider} />}
            <div className={`${style.row} ${isMe ? style.isMe : ''}`}>
                <div className={style.col}>
                    <div className={`${style.rank} ${isMarkRank && rankStyles[rank] || ''}`}>
                        <div className={`${style.rankText} ${rankFonts[rank.toString().length] || ''}`}>{rank}</div>
                    </div>
                </div>
                <div className={style.col}>
                    <div className={style.name}>{name}</div>
                </div>
                <div className={style.col}>
                    <div className={style.score}>{truncateExtraDecimals(score, scorePlaces)}</div>
                </div>
                {isPrizesAvailable && <div className={style.col}>
                    <div className={`${style.prize} ${isNoPrize ? style.isNoPrize : ''}`}>
                        {prizeDescription}
                    </div>
                </div>}
                </div>
        </>
    );
};

export const HeadRow = ({ isPrizesAvailable }) => {
    const t = usePortletTranslations();
    const headRows = ['rank', 'nickname', 'score'];
    isPrizesAvailable && headRows.push('prize');

    return (
        <div className={`${style.row} ${style.head}`}>
            {headRows.map((name, index) => (
                <div key={index} className={style.col}>{t(`competitorsTable.head.${name}`)}</div>
            ))}
        </div>
    );
};

export default ({ competitorsTable }) => {
    const isPrizesAvailable = competitorsTable.some(competitor => prop('prizeDescription', competitor));
    return (
        <div className={`${style.table} ${!isPrizesAvailable ? style.noPrizes : ''}`}>
            <HeadRow isPrizesAvailable={isPrizesAvailable} />
            {competitorsTable.map(({ rank, name, score, isMe, addDivider, prizeDescription }) => (
                <Row
                    key={rank}
                    isNoPrize={!prizeDescription}
                    prizeDescription={prizeDescription || '-'}
                    isMarkRank={rank <= 3 && Boolean(prizeDescription)}
                    {...{ name, rank, score, isMe, addDivider, isPrizesAvailable }}
                />
            ))}
        </div>
    );
};
